import { normalizeString } from '../../helpers/strings'

export const provinceMapper = province => {
  const { name, id, sectors } = province
  const cities = province.cities.map(city => {
    return { ...city, description: normalizeString(city.description) }
  })
  return { id, label: normalizeString(name), value: id, cities, sectors }
}
